export default __webpack_public_path__ + "static/media/make-a-call-banner.52ad3bb4.png";